import * as Datas from "@adminData";
import {axiosPostUtil} from "./axiosUtil";

const api = {
  admin: {
    login: async (params: {id: string; pw: string}) => {
      return await axiosPostUtil<
        Datas.ApiResponse<{
          token: {
            accessToken: string;
            refreshToken: string;
          };
        }>
      >("/api/v1/admin/login", params).then(value => value?.data);
    },

    getAdmin: async () => {
      return await axiosPostUtil<
        Datas.ApiResponse<{
          result: Datas.IAdmin;
          token: {
            accessToken: string;
            refreshToken: string;
          };
        }>
      >("/api/v1/admin/getAdmin").then(value => value?.data);
    },
  },

  board: {
    getList: async ({
      page = 1,
      limit = 20,
      ...args
    }: {
      page?: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<
          Datas.ResultPagingResponse<Datas.IBoardListResponse[]>
        >
      >("/api/v1/admin/board/getList", {page, limit, ...args}).then(
        value => value?.data,
      );
    },

    getDetail: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.IBoardResponse>>(
        "/api/v1/admin/board/getDetail",
        params,
      ).then(value => value?.data);
    },

    write: async (params: {
      title?: string;
      content?: string;
      files?: Datas.IFiles[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse<{no: number}>>(
        "/api/v1/admin/board/write",
        params,
      ).then(value => value?.data);
    },

    edit: async (params: {
      no: number;
      title?: string;
      content?: string;
      files?: Datas.IFiles[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/board/edit",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.ResultPagingResponse>>(
        "/api/v1/admin/board/delete",
        params,
      ).then(value => value?.data);
    },
  },

  notice: {
    getList: async ({
      page = 1,
      limit = 20,
      ...args
    }: {
      page?: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<
          Datas.ResultPagingResponse<Datas.INoticeListResponse[]>
        >
      >("/api/v1/admin/notice/getList", {page, limit, ...args}).then(
        value => value?.data,
      );
    },

    getDetail: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.INoticeResponse>>(
        "/api/v1/admin/notice/getDetail",
        params,
      ).then(value => value?.data);
    },

    write: async (params: {
      title: string;
      content: string;
      files?: Datas.IFiles[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse<{no: number}>>(
        "/api/v1/admin/notice/write",
        params,
      ).then(value => value?.data);
    },

    edit: async (params: {
      no: number;
      title: string;
      content: string;
      files?: Datas.IFiles[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/notice/edit",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.ResultPagingResponse>>(
        "/api/v1/admin/notice/delete",
        params,
      ).then(value => value?.data);
    },
  },

  info: {
    getHome: async () => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IInfo[]>>
      >("/api/v1/admin/info/getHome").then(value => value?.data);
    },

    getDetail: async (data: {type: string}) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IInfo>>
      >("/api/v1/admin/info/getDetail", data).then(value => value?.data);
    },

    save: async (data: Datas.IInfoSaveRequest[]) => {
      return await axiosPostUtil<Datas.ApiResponse>("/api/v1/admin/info/save", {
        info: data,
      }).then(value => value?.data);
    },
  },

  popup: {
    getList: async (params: {
      page: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IPopupResponse[]>>
      >("/api/v1/admin/popup/getList", params).then(value => value?.data);
    },

    getDetail: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.IPopupResponse>>(
        "/api/v1/admin/popup/getDetail",
        params,
      ).then(value => value?.data);
    },

    getPopup: async () => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IPopupResponse>>
      >("/api/v1/admin/popup/getPopup").then(value => value?.data);
    },

    write: async (params: {files?: Datas.IFiles[]}) => {
      return await axiosPostUtil<Datas.ApiResponse<{no: number}>>(
        "/api/v1/admin/popup/write",
        params,
      ).then(value => value?.data);
    },

    edit: async (params: {no: number; files?: Datas.IFiles[]}) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/popup/edit",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil("/api/v1/admin/popup/delete", params).then(
        value => value?.data,
      );
    },
  },

  adv: {
    getList: async () => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IAdvResponse[]>>
      >("/api/v1/admin/adv/getList").then(value => value?.data);
    },

    save: async (params: {
      type: string;
      no?: number;
      files?: Datas.IFiles[];
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IAdvResponse[]>>
      >("/api/v1/admin/adv/save", params).then(value => value?.data);
    },

    edit: async (params: {
      no: number;
      title?: string;
      content?: string;
      link?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IAdvResponse[]>>
      >("/api/v1/admin/adv/edit", params).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IAdvResponse[]>>
      >("/api/v1/admin/adv/delete", params).then(value => value?.data);
    },

    sort: async (params: {
      type: string;
      data: {no: number; ordering: number}[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/adv/sort",
        params,
      ).then(value => value?.data);
    },
  },

  member: {
    getList: async ({
      page = 1,
      limit = 20,
      ...args
    }: {
      sequnce?: number;
      page?: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IMemberResponse[]>>
      >("/api/v1/admin/member/getList", {page, limit, ...args}).then(
        value => value?.data,
      );
    },

    getDetail: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.IMemberResponse>>(
        "/api/v1/admin/member/getDetail",
        params,
      ).then(value => value?.data);
    },

    write: async (params: Datas.IMemberResponse) => {
      return await axiosPostUtil<Datas.ApiResponse<{no: number}>>(
        "/api/v1/admin/member/write",
        params,
      ).then(value => value?.data);
    },

    edit: async (params: Datas.IMemberResponse) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/member/edit",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse<Datas.ResultPagingResponse>>(
        "/api/v1/admin/member/delete",
        params,
      ).then(value => value?.data);
    },

    sort: async (params: {
      sequnce: number;
      data: {no: number; ordering: number}[];
    }) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/member/sort",
        params,
      ).then(value => value?.data);
    },
  },

  user: {
    getList: async ({
      page = 1,
      limit = 20,
      ...args
    }: {
      page?: number;
      limit?: number;
      searchTxt?: string;
    }) => {
      return await axiosPostUtil<
        Datas.ApiResponse<Datas.ResultPagingResponse<Datas.IUser[]>>
      >("/api/v1/admin/user/getList", {page, limit, ...args}).then(
        value => value?.data,
      );
    },

    confirm: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/user/confirm",
        params,
      ).then(value => value?.data);
    },

    confirmReset: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/user/confirmReset",
        params,
      ).then(value => value?.data);
    },

    delete: async (params: {no: number}) => {
      return await axiosPostUtil<Datas.ApiResponse>(
        "/api/v1/admin/user/delete",
        params,
      ).then(value => value?.data);
    },
  },
};

export default api;
